import JumpGame from './object/JumpGame';
import './index.css';

new JumpGame().start();

